module.exports = __webpack_public_path__ + "assets/img/recommend_bg.13220c6d.png";